import { useFeatureDonation } from 'hooks/use-feature-donation';
import { useDerivedServiceModeContext } from 'state/service-mode/derived';
import { useUnifiedMenuContext } from 'state/unified-menu/unified-menu-context';
import { getEntryPriceOrZero } from 'state/unified-menu/utils';

export type TDonation = {
  id: string;
  name: string;
  price: number;
};

export const useDonations = () => {
  const { featureDonation, loading } = useFeatureDonation();
  const { indexedMenu } = useUnifiedMenuContext();
  const { posServiceMode } = useDerivedServiceModeContext();

  const donations: TDonation[] = [];

  featureDonation?.donationItemList?.forEach(item => {
    if (!indexedMenu.isLoaded()) {
      return;
    }
    const menuItem = indexedMenu.find(item?._id || '');
    if (!menuItem) {
      return;
    }
    const price = getEntryPriceOrZero(menuItem, posServiceMode);
    if (price === 0) {
      return;
    }
    donations.push({
      id: item?._id || '',
      name: item?.name?.locale || '',
      price,
    });
  });

  return { loading, donations, isDonationsEnabled: donations.length > 0 };
};
